import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新建坏账批次")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("加入到已有批次")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("加入此包")

import { ref, reactive, onBeforeMount, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, getNumber, exportHandle } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/bad_debt/finance/unreceived_payments/query': fetchList,
  // 坏账_待收款订单_确认坏账
  'POST/bad_debt/finance/unreceived_payments/confirm_bab_debt': confirm_bab_debtApi,
  // 坏账_坏账批次_新建坏账批次
  'POST/bad_debt/pack/create_pack': create_packApi,
  // 坏账_坏账批次_分页查询
  'POST/bad_debt/pack/query': packQueryApi,
  // 坏账_坏账批次_加入到一个批次
  'POST/bad_debt/pack/add_to_pack': add_to_packApi,
  // 
  'POST/bad_debt/finance/unreceived_payments/download': downloadApi,
} = Api

let seleRows = ref([])
const tableEle = ref()
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_height
} = new tbMix(fetchList)

const searchEle = ref()
const searchObj = reactive({
  owner: '', customer: '', orderNo: '', extraDays: undefined, invoiceCompany: ''
})
const searchHandle = () => {
  return fetchData(searchObj)
}
searchHandle()

// 本位币合计金额
const totalAmount = computed(() => seleRows.value.reduce((number: number, row: any) => number + row.standardMoney, 0))

// 确认申报
const isShowConfirm = ref<boolean>(false)
const isEnforced = ref<boolean>(false)
const confirmHandle = () => {
  MI_identify.value = true
  confirm_bab_debtApi({
    idList: seleRows.value.map((e: {id: number}) => e.id),
    isEnforced: isEnforced.value
  }).then(() => {
    ElMessage.success('确认成功')
    MI_identify.value = false
    isShowConfirm.value = false
    searchHandle()
  }).finally(() => {
    MI_identify.value = false
  })
}

// 新建坏账模板
const createdHandle = () => {
  ElMessageBox.prompt('名称:', '新建坏账批次', {
    inputPattern: /.+/,
    inputErrorMessage: '请输入名称',
  }).then(({ value }) => {
    MI_identify.value = true
    return create_packApi({
      name: value,
      orderIds: seleRows.value.map((e: {id: number}) => e.id),
    })
  }).then(() => {
    ElMessage.success('创建成功')
    MI_identify.value = false
    searchHandle()
  }).finally(() => {
    MI_identify.value = false
  })
}
// 加入到已有坏账批次
const isShowAdd = ref<boolean>(false)
const addSearch = ref('')
const { 
  MI_tableData: addDate, fetchData: fetchAdd, page: addPage, size: addSize,
  MI_total: addTotal, MI_pageChange: addPageCg, MI_identify: addLoad, MI_sizeChange: addSzCg
} = new tbMix(packQueryApi)
const showAdd = () => {
  isShowAdd.value = true
  addSearch.value = ''
  fetchAdd({status: 'NOT_INITIATED'})
}
const addHandle = (row: {id: number}) => {
  ElMessageBox.confirm('请确认是否加入此包', '提示').then(() => {
    addLoad.value = true
    return add_to_packApi({
      packId: row.id,
      orderIds: seleRows.value.map((e: {id: number}) => e.id),
    })
  }).then(() => {
    addLoad.value = false
    ElMessage.success('加入成功')
    isShowAdd.value = false
    searchHandle()
  }).finally(() => {
    addLoad.value = false
  })
}

// 导出
const expHandle = () => {
  ElMessageBox.confirm('请确认是否导出', '提示').then(() => {
    MI_params.value = true
    return exportHandle(downloadApi, {
      ...MI_params,
      idList: seleRows.value.map((e: {id: number}) => e.id),
    })
  })
  .then(() => {
    ElMessage.success('导出成功')
  }).finally(() => {
    MI_params.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_link = _resolveComponent("el-link")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "searchEle",
              ref: searchEle,
              model: _unref(searchObj),
              inline: "",
              class: "searchBg",
              disabled: _unref(MI_identify)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "订单号:",
                  prop: "orderNo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).orderNo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).orderNo) = $event)),
                      clearable: "",
                      maxlength: "100",
                      placeholder: "请输入订单号",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户名称:",
                  prop: "customer"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).customer,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).customer) = $event)),
                      clearable: "",
                      maxlength: "100",
                      placeholder: "请输入客户名称",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户经理:",
                  prop: "owner"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).owner,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).owner) = $event)),
                      clearable: "",
                      maxlength: "100",
                      placeholder: "请输入客户经理",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "开票主体:",
                  prop: "invoiceCompany"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).invoiceCompany,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).invoiceCompany) = $event)),
                      clearable: "",
                      maxlength: "100",
                      placeholder: "请输入客户经理",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_1,
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (searchHandle())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {searchEle.value.resetFields(); _unref(searchObj).extraDays = undefined})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_input_number, {
      controls: false,
      modelValue: _unref(searchObj).extraDays,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchObj).extraDays) = $event)),
      precision: 0,
      min: 0,
      class: "form-input",
      placeholder: "交付日期超期天数,如:30",
      onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (searchHandle()), ["enter"]))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_button, {
      icon: "search",
      onClick: _cache[8] || (_cache[8] = ($event: any) => (searchHandle()))
    }),
    _createVNode(_component_el_button, {
      onClick: _cache[9] || (_cache[9] = ($event: any) => (createdHandle())),
      type: "primary",
      disabled: _unref(seleRows).length === 0
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_button, {
      onClick: _cache[10] || (_cache[10] = ($event: any) => (showAdd())),
      type: "primary",
      disabled: _unref(seleRows).length === 0
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_button, {
      onClick: _cache[11] || (_cache[11] = ($event: any) => (expHandle())),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["disabled"]),
    (_unref(seleRows).length !== 0)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          type: "warning",
          closable: false,
          class: "mt-10",
          title: `共${_unref(MI_total)}条, 已选择${_unref(seleRows).length}条, 本位币总计: ${_unref(getNumber)(_unref(totalAmount))}元`
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref_key: "tableEle",
      ref: tableEle,
      border: "",
      data: _unref(MI_tableData),
      onSelectionChange: _cache[12] || (_cache[12] = (rows) => _isRef(seleRows) //@ts-ignore
 ? seleRows.value = rows : seleRows = rows),
      "max-height": _unref(MI_height) - 80 + 'px',
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单号",
          prop: "no",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单名称",
          prop: "name",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户ID",
          prop: "customerUsername",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户名称",
          prop: "customer",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户联系人",
          prop: "customerContactor",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户经理",
          prop: "owner",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "开票主体",
          prop: "invoiceCompany",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "金额",
          prop: "amount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "本位币",
          prop: "standardMoney",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "开始日期",
          prop: "startTime",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "交付日期",
          prop: "deliverTime",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单状态",
          prop: "status"
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      total: _unref(MI_total),
      background: "",
      small: "",
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[13] || (_cache[13] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[14] || (_cache[14] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-sizes": [30, 50, 100, 300],
      class: "mt-10",
      disabled: _unref(MI_identify),
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "disabled", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowConfirm.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((isShowConfirm).value = $event)),
      title: "是否强制执行",
      width: "400px",
      "show-close": false,
      onClose: _cache[19] || (_cache[19] = ($event: any) => (isEnforced.value = false))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[16] || (_cache[16] = ($event: any) => (isShowConfirm.value = false)),
          disabled: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          onClick: _cache[17] || (_cache[17] = ($event: any) => (confirmHandle())),
          type: "primary",
          loading: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_radio_group, {
          modelValue: isEnforced.value,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((isEnforced).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, {
              label: true,
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio, {
              label: false,
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowAdd.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((isShowAdd).value = $event)),
      title: "加入到已有批次"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          placeholder: "请输入批次名称",
          modelValue: addSearch.value,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((addSearch).value = $event)),
          clearable: "",
          maxlength: "100",
          class: "form-input",
          disabled: _unref(addLoad)
        }, null, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[21] || (_cache[21] = ($event: any) => (_unref(fetchAdd)({name: addSearch.value, status: 'NOT_INITIATED'}))),
          class: "ml-10",
          disabled: _unref(addLoad)
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["disabled"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _unref(addDate),
          border: "",
          "max-height": "550px",
          class: "mt-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "批次名称",
              prop: "name",
              width: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "创建人",
              prop: "createName",
              width: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "创建时间",
              prop: "createTime",
              width: ""
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (addHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(addLoad)]
        ]),
        _createVNode(_component_el_pagination, {
          total: _unref(addTotal),
          small: "",
          style: {"float":"none"},
          "page-size": _unref(addSize),
          "onUpdate:page-size": _cache[22] || (_cache[22] = ($event: any) => (_isRef(addSize) ? (addSize).value = $event : null)),
          currentPage: _unref(addPage),
          "onUpdate:currentPage": _cache[23] || (_cache[23] = ($event: any) => (_isRef(addPage) ? (addPage).value = $event : null)),
          "page-sizes": [30, 50, 100, 300],
          class: "mt-10",
          disabled: _unref(addLoad),
          layout: "sizes, prev, pager, next, total, jumper",
          onCurrentChange: _unref(addPageCg),
          onSizeChange: _unref(addSzCg)
        }, null, 8, ["total", "page-size", "currentPage", "disabled", "onCurrentChange", "onSizeChange"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})